module.exports = __webpack_public_path__ + "img/sh001.8505f705.png";